import { UserModule } from '@/store/modules/user'

interface Button {
    id: string;
    name: string;
    detail: string;
}

/**
 * @des 页面中的按钮是否有权限
 * @param id 按钮对应的id 
 * **/
export const menuBtn = function(id: number) {
    let bol =false
    UserModule.buttons.forEach((item: any) => {
        if(item.id == id) bol = true
    })
    return bol
}